import { config } from '../Constants';

var url = config.url.API_URL;
export default {
    Resident: {
        GetDematAccountCountAPI: url + '/GetDematAccountCount',
        GetDematAccountDetailsAPI: url + '/GetDematAccountDetails',
        GetDematAccountAssignmentDetailsAPI: url + '/GetDematAccountAssignmentDetails',
        LogotherAPI: url + '/Logother'
    },
    Form15GH: {
        GetDetailsDDLAPI: url + '/GetDetailsDDL',
        IForm15GHAPI: url + '/InsertForm15GHDetails',
        CheckSubsequentDividendsAPI: url + '/CheckSubsequentDividends',

        AcceptForm15GHAPI: url + '/AcceptForm15GH',

        PreviewForm15GHDetailsAPI: url + '/PreviewForm15GHDetails',
        GetDetailsAPI: url + '/GetForm15GHDetails',
        UploadSignDoc: url + '/UploadSignDocument',
        DownloadBulkDetailsAPI: url + '/Form15GHDetailsByAdmin?assignmentCode=',
        DownloadPdfAPI: url + '/DownloadPdfFile?pdfLocation=',
        DownloadPdfBase64API: url + '/DownloadPdfBase64File?pdfLocation=',
        DSigatureAPI: url + '/upload',
        SignPdfAPI: url + '/SignPdf?pdfLocation=',
        DownloadSignedPdfAPI: url + '/DownloadSignedPdf',
        DownloadDigiSignedPdfAPI: url + '/DownloadDigiSignedPdf',
        DownloadNRDocumentsAPI: url + '/DownloadNRDocuments',
        SubmitForm15GHAPI: url + '/SubmitForm15GH',
        GetForm15GHDeclarationDetailsAPI: url + '/GetForm15GHDeclarationDetails',
        GetForm15GHDeclarationCountAPI: url + '/GetForm15GHDeclarationCount',
        GetTaxLimitAPI: url + '/GetForm15GHGetTaxLimit',
        GetOfflineDetailsAPI: url + '/GetOfflineForm15GHDetails',
        GetCompletedForm15GHAPI: url + '/GetCompletedForm15GH',
        GetManuallyTaxLimitAPI: url + '/GetManuallyForm15GHGetTaxLimit',
    },
    Form121: {
        GetDetailsDDLAPI: url + '/GetDetailsDDL',
        IForm121API: url + '/InsertForm121Details',
        CheckSubsequentDividendsAPI: url + '/CheckSubsequentDividends',

        AcceptForm121API: url + '/AcceptForm121',

        PreviewForm121DetailsAPI: url + '/PreviewForm121Details',
        GetDetailsAPI: url + '/GetForm121Details',
        UploadSignDoc: url + '/Upload121SignDocument',
        DownloadBulkDetailsAPI: url + '/Form121DetailsByAdmin?assignmentCode=',
        DownloadPdfAPI: url + '/DownloadForm121PdfFile?pdfLocation=',
        DownloadPdfBase64API: url + '/Download121PdfBase64File?pdfLocation=',
        DSigatureAPI: url + '/upload',
        SignPdfAPI: url + '/Sign121Pdf?pdfLocation=',
        DownloadSignedPdfAPI: url + '/Download121SignedPdf',
        DownloadDigiSignedPdfAPI: url + '/Download121DigiSignedPdf',
        DownloadNRDocumentsAPI: url + '/DownloadNRDocuments',
        SubmitForm121API: url + '/SubmitForm121',
        GetForm121DeclarationDetailsAPI: url + '/GetForm121DeclarationDetails',
        GetForm121DeclarationCountAPI: url + '/GetForm121DeclarationCount',
        GetTaxLimitAPI: url + '/GetForm121GetTaxLimit',
        GetOfflineDetailsAPI: url + '/GetOfflineForm121Details',
        GetCompletedForm121API: url + '/GetCompletedForm121',
        GetManuallyTaxLimitAPI: url + '/GetManuallyForm121GetTaxLimit',
    },
    UserManagement: {
        LoginAPI: url + '/Login',
        RefreshCookiesAPI: url + '/RefreshCookies',
        GetUserProfileAPI: url + '/GetUserProfile?PAN=',
        CompleteProfileAPI: url + '/CompleteShareholderProfile',
        ValidateOtpAPI: url + '/ValidateOTP?OTP=',
        VerifyUserAPI: url + '/VerifyShareholder',
        VerifyPANAPI: url + '/VerifyPAN',
        LogoutAPI: url + '/Logout',
        GetRemitterIDAPI: url + '/GetRemitter?RemitterCode=',
        ForgetPasswordAPI: url + '/ForgetPassword',
        GetSessionDetailsAPI: url + '/GetSessionDetails',
        GetTermsOfUseAPI: url + '/GetTermsOfUse',
        UpdateTermsOfUseAPI: url + '/UpdateTermsOfUse',
        VerifyDPIDAPI: url + '/VerifyDPID',
        CheckPANinMultipleTypeAPI: url + '/CheckPANinMultipleType',
        GetCompanyDetailsDDLAPI: url + '/GetCompanyDetailsDDL',
        SetClientIpAPI: url + '/SetClientIp',
        GetNRSubmittedDetailsAPI: url + '/GetNRSubmittedDetails',

        GetAllCompaniesDDLAPI: url + '/GetAllCompaniesDDL',
        SendDeclarationMailAPI: url + '/SendDeclarationMail',
        UploadFilesNonResidentAPI: url + '/UploadFilesNonResident',
        UploadFilesOtherResidentAPI: url + '/UploadFilesOtherResident',
        SendOTPEmailAPI: url + '/SendOTPEmail',
        SendResetOTP: url + '/SendResetOTP',
        ResetPasswordNew: url + '/ResetPasswordNew',
        ValidateResetOTPNew: url + '/ValidateResetOTPNew',

        ValidateOTPNewAPI: url + '/ValidateOTPNew',
        SignInAPI: url + '/SignInNew',
        GetcompanyListDDLAPI: url + '/GetcompanyList'


    },
    Assignment: {
        GetAssignmentAPI: url + '/GetAssignment',
        GetIdWiseDetailsAPI: url + '/GetIdWiseDetails?Id=',
        IAssignmentAPI: url + '/InsertAssignmentDetails',
        UploadFileAPI: url + '/UploadShareholders',
        DownloadSampleAPI: url + '/DownloadSample',
        DownloadAssignmentLogAPI: url + '/DownloadAssignmentLog',
    },
    Beneficiary: {
        GetBeneficiaryDetailsAPI: url + '/GetBeneficiaryDetails',
        GetIdWiseProfileAPI: url + '/GetBenDetails?beneficiaryID=',
        IBeneficiaryAPI: url + '/InsertBeneficiaryDetails',
        ExportBeneficiaryDetailsAPI: url + '/ExportBeneficiaryDetails',
    },
    Notification: {
        GetNotificationAPI: url + '/GetNotificationDetails'
    },
    BulkUpload: {
        UploadFileAPI: url + '/BulkXMLGenerationPost'
    },
    Part2: {
        GetPart2API: url + '/GetPart2',
        DownloadBulkDetailsPart2API: url + '/Part2Form15GHDetailsByAdmin?assignmentCode=',
        UploadPart2Shareholder: url + '/UploadPart2ShareholderDetails'
    },
    Role: {
        Role1: 'Admin',
        Role2: 'Shareholder',
    },
    Message: {
        RequiredMessage: "All fields are required.",
        SuccessMessage: "Data saved successfully.",
        SubmitMessage: "Declaration Submitted Successfully.",
        FileInvalidMessage: 'Assignment saved but file is invalid..',
        FormatRequiredMessage: "Only .xlsx and .xls files are valid.",
        PDFFormatRequiredMessage: "Only .pdf files are valid.",
        FailedSave: "Failed to save.",
        SpecifiedFormatRequiredMessage: "File with only specified format is valid",
        FileSize10MBMessage: "File size must be less than or equal to 10 MB.",
    },
    URLs: {
        LoginUrl: `/${localStorage.getItem('remitterCode')}`,
        verifyUserUrl: "/:CompanyName/New-User",
        forgetPasswordUrl: "/:CompanyName/forgetPassword",
        userProfileUrl: "/:CompanyName/userProfile",
        homeUrl: `/${localStorage.getItem('remitterCode')}/Dashboard`,
        fetchRemitter: "/:CompanyName/fetchRemitter",
        fetchAssignmentUrl: "/:CompanyName/Assignment",
        addEditAssignmentUrl: "/:CompanyName/Modify-Assignment",
        form15GHUrl: `/${localStorage.getItem('remitterCode')}/Form15GH`,
        fetchBeneficiaryUrl: "/:CompanyName/Shareholder-Details",
        editBeneficiaryUrl: "/:CompanyName/Modify-Shareholder",
        fetchPart2Url: "/:CompanyName/Part2"
    },
    OfflineResident: {
        GetcompanyListDDLAPI: url + '/GetcompanyList',
        GetAssignmentCodeAPI: url + '/GetAssignmentCode',
        SubmitOfflineForm15GHAPI: url + '/SubmitOfflineForm15GH',
        SubmitOfflineManuallyForm15GHAPI: url + '/SubmitOfflineManuallyForm15GH',
        SendManuallyDataEmailAPI: url + '/SendManuallyDataEmail',
        SubmitOfflineNRForm15GHAPI: url + '/SubmitOfflineNRForm15GH'
        //DownloadTemplateAPI: url + '/DownloadTemplate'
    },
    IpAddress: ""
};